import { AdminButton, AdminInfo } from '@/types'
import { clientGET } from './client'

const adminApiBase = '/sportdata/1/webadmin'

export const getAdminInfo = async (
  token: string,
  leagueId?: string,
  teamId?: string,
  clubId?: string,
  gameId?: string
): Promise<{ data: AdminInfo[] }> => {
  return clientGET({
    url: adminApiBase + '/info',
    params: {
      leagueId: leagueId,
      teamId: teamId,
      clubId: clubId,
      gameId: gameId
    },
    token
  })
}
export const getAdminButtons = async (
  token: string,
  leagueId?: string,
  teamId?: string,
  clubId?: string,
  gameId?: string
): Promise<{ data: AdminButton[] }> => {
  return clientGET({
    url: adminApiBase + '/buttons',
    params: {
      leagueId: leagueId,
      teamId: teamId,
      clubId: clubId,
      gameId: gameId
    },
    token
  })
}

// @GET
//   @Path("/info")
//   public List<AdminInfo> getWebAdminInfo(
//       @QueryParam("leagueId") String leagueId,
//       @QueryParam("gameId") String gameId,
//       @QueryParam("teamId") String teamId,
//       @QueryParam("clubId") String clubId
//   ) {
//   @GET
//   @Path("/buttons")
//   public List<AdminButton> getWebAdminButtons(
//       @QueryParam("leagueId") String leagueId,
//       @QueryParam("gameId") String gameId,
//       @QueryParam("teamId") String teamId,
//       @QueryParam("clubId") String clubId
//   ) {
